export default class BaseGarbageCollectionPluginText extends Phaser.Plugin {
  constructor ( game ) {
    super( game );
    this.localGarbage = [];
  }
  destroy () {
    super.destroy();
  }
}
